<div class="card">
  <div class="card-body d-flex flex-column gap-2">
    <strong>{{ 'help-curation.import.title' | translate }}</strong>
    <p class="text-secondary small mb-0">{{ 'help-curation.import.intro' | translate }}</p>

    <input type="file" class="form-control" accept=".xlsx" #fileInput (change)="onFileSelected($event)" />
    <button type="button" class="btn btn-primary" [disabled]="!importFile() || isImporting()" (click)="startImport()">
      {{ 'help-curation.import.start' | translate }}
    </button>

    @if (isImporting()) {
      <p class="text-secondary mb-0">{{ 'help-curation.import.processing' | translate }}</p>
    }

    @if (importError()) {
      <div class="alert alert-danger mb-0">{{ 'help-curation.import.error' | translate }}</div>
    }

    @if (importStatus(); as result) {
      @if (result.status === 'complete') {
        <div class="alert alert-success mb-0">
          {{ 'help-curation.import.done' | translate }} — {{ 'help-curation.import.added' | translate }}:
          {{ result.added }}, {{ 'help-curation.import.updated' | translate }}: {{ result.updated }},
          {{ 'help-curation.import.skipped' | translate }}: {{ result.skipped }},
          {{ 'help-curation.import.failed' | translate }}: {{ result.failed }}
        </div>
      }
    }
  </div>
</div>
